export { default } from './BlockEuropeNews'
